import { createSlice, PayloadAction } from '@reduxjs/toolkit'

export type MediaSliceState = {
  scrollTopPx: number
}

export const initialState: MediaSliceState = {
  scrollTopPx: 0
}

export const slice = createSlice({
  name: 'media',
  initialState,
  reducers: {
    setScrollTopPx: (state, action: PayloadAction<number>) => {
      state.scrollTopPx = action.payload
    }
  }
})

export const actions = slice.actions
export const reducer = slice.reducer
